module.exports = __webpack_public_path__ + "img/template_icon.abfc1781.svg";